import { Directive, Input, OnChanges, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Permission } from 'src/app/common/enums/permissions';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Directive({
  selector: '[hasPermission]',
  standalone: false
})
export class HasPermissionDirective implements OnChanges {
  private view = inject(ViewContainerRef);
  private template = inject<TemplateRef<any>>(TemplateRef);
  private authService = inject(AuthService);

  @Input('hasPermission') permissions: Permission[];

  constructor() { }

  async ngOnChanges() {
    if (await firstValueFrom(this.authService.isAuthenticated$) && this.permissions.some((p) => this.authService.hasPermission(p))) {
      this.view.createEmbeddedView(this.template);
    } else {
      this.view.clear();
    }
  }
}
